import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useGoFurtherSectionStyles = makeStyles(() => ({
  goFurtherSection: {
    position: 'relative',
    marginTop: spacing.xl,
    padding: '56px 0',
    backgroundColor: colors.background,
    display: 'flex',
    justifyContent: 'center',
  },
  goFurtherContainer: {
    position: 'relative',
    width: '100%',
    margin: '0 auto',
    padding: `${spacing.lg}px ${spacing.sm}px`,
    border: `1px solid ${colors.brownDark}`,
    borderRadius: radius.md,
    backgroundColor: colors.background,
    boxSizing: 'border-box',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      padding: `${spacing.lg}px 48px`,
    },
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: `${spacing.lg}px 128px`,
    },
  },
  goFurtherContainerContactOnly: {
    width: 'fit-content',
    maxWidth: '100%',
    padding: `${spacing.lg}px ${spacing.xl}px`,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      padding: `${spacing.lg}px 96px`,
    },
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      padding: `${spacing.lg}px 96px`,
    },
  },
  goFurtherTitle: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    margin: 0,
    padding: `${spacing.xs}px ${spacing.md}px`,
    backgroundColor: colors.background,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.intro,
    color: colors.textBody,
    lineHeight: 'normal',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  goFurtherContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.lg,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 48,
    },
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      gap: 118,
    },
  },
  goFurtherContentContactOnly: {
    justifyContent: 'center',
  },
  goFurtherShopColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.md,
    width: '100%',
    maxWidth: 400,
    textAlign: 'center',
  },
  goFurtherShopTitle: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 'normal',
  },
  goFurtherShopImage: {
    width: 110,
    height: 'auto',
    maxHeight: 184,
    objectFit: 'contain',
  },
  goFurtherShopDescription: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
    width: '100%',
  },
  goFurtherShopDescriptionLine: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 'normal',
  },
  goFurtherShopDescriptionLineEmphasis: {
    fontFamily: fonts.opensansSemiBold,
  },
  goFurtherShopButton: {
    ...primaryButtonStyle,
    backgroundColor: colors.text,
    '&:hover': {
      backgroundColor: colors.text,
      opacity: 0.92,
    },
  },
  goFurtherShopSecondary: {
    margin: 0,
    padding: 0,
    border: 0,
    background: 'none',
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    textDecoration: 'underline',
    textUnderlineOffset: 2,
    textAlign: 'center',
  },
  goFurtherContactCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 31,
    width: '100%',
    maxWidth: 490,
    padding: spacing.lg,
    borderRadius: radius.sm,
    border: '1px solid #dfdad5',
    borderTopWidth: 11,
    borderTopColor: '#dfdad5',
    backgroundColor: '#fbf9f7',
    boxSizing: 'border-box',
  },
  goFurtherContactInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.md,
    width: '100%',
  },
  goFurtherContactIcon: {
    width: 48,
    height: 48,
    color: colors.text,
  },
  goFurtherContactText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.sm,
    textAlign: 'center',
    width: '100%',
  },
  goFurtherContactTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.base,
    color: colors.text,
    lineHeight: 'normal',
  },
  goFurtherContactDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
  },
  goFurtherContactButton: {
    ...secondaryButtonStyle,
  },
}));
